import React, { useContext, useState } from 'react'
import styled from 'styled-components'

import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import TextButton from 'components/Luxkit/Button/TextButton'
import { useRef } from 'react'
import NavigationHeaderContactDropdown from './NavigationHeaderContactDropdown'
import DropdownChevron from 'components/Luxkit/Dropdown/DropdownChevron'
import ContactContext from 'contexts/contactContext'

const ItemContainer = styled.div`
  position: relative;
`

interface Props {
  className?: string;
}

function NavigationHeaderPhoneMenu({
  className,
}: Props) {
  const [isOpen, setOpen] = useState(false)
  const triggerRef = useRef(null)
  const currentContact = useContext(ContactContext)
  const localContact = currentContact.local
  const internationalContact = currentContact.international
  const onPhoneToggle = () => {
    setOpen(!isOpen)
  }

  return (
    <ItemContainer className={className}>
      <TextButton
        kind="tertiary"
        variant="dark"
        onClick={onPhoneToggle}
        aria-expanded={isOpen}
        aria-label="Need Help? Call our Travel Experts"
        startIcon={<LinePhoneIcon />}
        endIcon={<DropdownChevron open={isOpen}/>}
        ref={triggerRef}
      >
        {localContact.humanReadable || internationalContact.humanReadable}
      </TextButton>
      <NavigationHeaderContactDropdown
        isOpen={isOpen}
        onPhoneToggle={onPhoneToggle}
        triggerRef={triggerRef}
      />
    </ItemContainer>
  )
}

export default NavigationHeaderPhoneMenu
